<template>
    <div v-if="isLoaded">
        <div class="content-body" v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card" style="">
                        <div class="card-header">
                            <v-tour name="blogisticTour" :steps="steps" :callbacks="callbacksTour"></v-tour>
                            <h4 class="card-title">Gerar CTE Veicular</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"  v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                    <li><a @click="onCreate()" v-b-tooltip title="Gerar CTE"><i class="ft-plus"></i></a></li>
                                    <li><a @click="onOcultar(2, null, false)" v-b-tooltip title="Mostrar Documentos"><i class="ft-eye"></i></a></li>
                                    <li><a @click="onOcultar(1, null, false)" v-b-tooltip title="Ocultar Documentos"><i class="ft-eye-off"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Expande a tela" v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHide()" v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table-responsive">
                                <div v-if="vuetableFilterRow">
                                    <vuetable-filterbar>
                                    </vuetable-filterbar>
                                </div>
                                <div class="loadingDataPosition">
                                    <div class="loadingData" v-if="loadingData">
                                        <div class="loadingDataSpinner">
                                            <spinner v-if="loadingData" text-fg-color="#ffffff" message="Carregando..."></spinner>
                                        </div>
                                    </div>
                                    <vuetable ref="vuetable"
                                        api-url="/api/cteveiculo"
                                        :fields="fields"
                                        :css="css"
                                        :append-params="moreParams"
                                        track-by="docfis_id"
                                        pagination-path=""
                                        @vuetable:pagination-data="onPaginationData"
                                        @vuetable:cell-clicked="onDetail"
                                        @vuetable:loaded="onLoaded"
                                        detail-row-component="cte-veiculo-detalhes"
                                      >
                                      <template slot="actions" slot-scope="props">
                                        <div class="custom-actions">
                                            <a @click="onDetail(props.rowData, null, null)" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                                            <a v-if="props.rowData.ocultar==2" @click="onOcultar(1, props.rowData, true)" v-b-tooltip title="Ocultar"><i class="fa fa-eye-slash"></i></a>
                                            <a v-if="props.rowData.ocultar==1" @click="onOcultar(2, props.rowData, true)" v-b-tooltip title="Mostrar"><i class="fa fa-eye"></i></a>
                                          </button>
                                        </div>
                                      </template>
                                    </vuetable>
                                </div>
                            <div>
                                <div class='col-md-12'>
                                    <div class="pull-left pagination-detail">
                                        <vuetable-pagination-info ref="paginationInfo"
                                                                  :css="css.pagination"
                                                                  info-class="pull-left"
                                        ></vuetable-pagination-info>
                                    </div>
                                    <div class="pull-right m-a-0">
                                        <vuetable-pagination ref="pagination"
                                                             :css="css.pagination"
                                                             @vuetable-pagination:change-page="onChangePage"
                                        ></vuetable-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            <!-- Modal Component -->
            <b-modal id="modal_form"
                     ref="modal_form"
                     size="lg"
                     :title="modal_titulo"
                     :ok-title="modal_botao"
                     close-title="Fechar"
                     v-model="showModal"
                     :ok-disabled=form.errors.any()
                     @ok="handleOk">
                <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
                    <b-container fluid>
                        <b-row>
                            <b-col class="p-a-0">
                                <label>CST</label>
                                <b-form-input type="text"
                                                placeholder="CST"
                                                v-model="form.cst"
                                                name="cst"
                                                >
                                </b-form-input>
                                <b-form-feedback class="text-danger" v-text="form.errors.get('cst')" v-if="form.errors.has('cst')"></b-form-feedback>
                            </b-col>
                            <b-col class="p-a-0">
                                <label>CFOP</label>
                                <multiselect v-model="form.cfop"
                                :options="optionsLivCfop"
                                track-by="value"
                                label="label"
                                :hide-selected="true"
                                placeholder="Selecione"
                                tag-placeholder="Selecionar"
                                select-label="Selecionar"
                                selected-label="Selecionado"
                                deselect-label="Remover"
                                ></multiselect>
                                <b-form-feedback class="text-danger" v-text="form.errors.get('cfop')" v-if="form.errors.has('cfop')"></b-form-feedback>
                            </b-col>
                            <b-col class="p-a-0">
                                <label>Porto de Origem <span v-b-tooltip title="Portos com município vinculado e status ativo" placement="top">[?]</span></label>
                                <multiselect v-model="form.porto_origem"
                                :options="optionsPortoOrigem"
                                track-by="value"
                                label="label"
                                :hide-selected="true"
                                placeholder="Selecione"
                                tag-placeholder="Selecionar"
                                select-label="Selecionar"
                                selected-label="Selecionado"
                                deselect-label="Remover"
                                ></multiselect>
                                <b-form-feedback class="text-danger" v-text="form.errors.get('porto_origem.value')" v-if="form.errors.has('porto_origem.value')"></b-form-feedback>
                            </b-col>
                            <b-col class="p-a-0">
                                <label>Porto de Transbordo<span v-b-tooltip title="Portos com município vinculado e status ativo" placement="top">[?]</span></label>
                                <multiselect v-model="form.porto_transbordo"
                                :options="optionsPortoTransbordo"
                                track-by="value"
                                label="label"
                                :hide-selected="true"
                                placeholder="Selecione"
                                tag-placeholder="Selecionar"
                                select-label="Selecionar"
                                selected-label="Selecionado"
                                deselect-label="Remover"
                                ></multiselect>
                                <b-form-feedback class="text-danger" v-text="form.errors.get('porto_transbordo.value')" v-if="form.errors.has('porto_transbordo.value')"></b-form-feedback>
                            </b-col>
                            <b-col class="p-a-0">
                                <label>Porto de Destino<span v-b-tooltip title="Portos com município vinculado e status ativo" placement="top">[?]</span></label>
                                <multiselect v-model="form.porto_destino"
                                :options="optionsPortoDestino"
                                track-by="value"
                                label="label"
                                :hide-selected="true"
                                placeholder="Selecione"
                                tag-placeholder="Selecionar"
                                select-label="Selecionar"
                                selected-label="Selecionado"
                                deselect-label="Remover"
                                ></multiselect>
                                <b-form-feedback class="text-danger" v-text="form.errors.get('porto_destino.value')" v-if="form.errors.has('porto_destino.value')"></b-form-feedback>
                            </b-col>
                        </b-row>
                    </b-container>
                    <b-container fluid>
                        <b-row>
                            <b-col class="p-a-0">
                              <h3 class="panel-title with-border p-a-0 m-a-0 p-t">Valores</h3>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="p-a-0">
                                <label>Valor Líquido</label>
                                <input v-model.lazy="form.vlr_cte"
                                v-money="vlr"
                                v-on:keyup="calcCte"
                                name="vlr_cte"
                                type="text"
                                class="form-control"
                                style="text-align: right" />
                                <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_cte')" v-if="form.errors.has('vlr_cte')"></b-form-feedback>
                            </b-col>
                            <b-col class="p-a-0">
                                <label>Alíquota</label>
                                <input v-model.lazy="form.vlr_aliquota"
                                     v-money="aliquota"
                                     v-on:keyup="calcCte"
                                     name="vlr_aliquota"
                                     type="text"
                                     class="form-control"
                                     style="text-align: right" />
                                <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_aliquota')" v-if="form.errors.has('vlr_aliquota')"></b-form-feedback>
                            </b-col>
                            <b-col class="p-a-0">
                                <label>Imposto</label>
                                <input v-model.lazy="form.vlr_imposto"
                                v-money="vlr"
                                name="vlr_imposto"
                                type="text"
                                class="form-control"
                                style="text-align: right" />
                                <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_imposto')" v-if="form.errors.has('vlr_imposto')"></b-form-feedback>
                            </b-col>
                            <b-col class="p-a-0">
                                <label>Valor Total do CTE</label>
                                <input v-model.lazy="form.vlr_total"
                                v-money="vlr"
                                name="vlr_total"
                                type="text"
                                class="form-control"
                                readonly="true"
                                style="text-align: right" />
                                <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_total')" v-if="form.errors.has('vlr_total')"></b-form-feedback>
                            </b-col>
                            <b-col class="p-a-0">
                                <label>% Afrmm</label>
                                <input v-model.lazy="form.vlr_aliquota_afrmm"
                                v-money="aliquota"
                                name="vlr_aliquota_afrmm"
                                type="text"
                                class="form-control"
                                style="text-align: right" />
                                <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_aliquota_afrmm')" v-if="form.errors.has('vlr_aliquota_afrmm')"></b-form-feedback>
                            </b-col>
                        </b-row>
                    </b-container>
                    <b-container fluid class="p-t p-l-0 p-r-0">
                        <b-tabs>
                            <b-tab title="Detalhes" active>
                                <b-container fluid>
                                    <b-row>
                                        <b-col class="p-a-0">
                                          <label>Expedidor</label>
                                          <multiselect v-model="form.expedidor"
                                          :options-limit="300"
                                          :limit="2"
                                          :limit-text="limitText"
                                          :options="optionsExpedidor"
                                          track-by="value"
                                          label="label"
                                          :hide-selected="true"
                                          placeholder="Expedidor ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"
                                          tag-placeholder="Selecionar"
                                          select-label="Selecionar"
                                          selected-label="Selecionado"
                                          deselect-label="Remover"
                                          :searchable="true"
                                          :loading="isLoadingExp"
                                          @search-change="listaClientesExpedidor"
                                          ></multiselect>
                                          <b-form-feedback class="text-danger" v-text="form.errors.get('expedidor.value')" v-if="form.errors.has('expedidor.value')"></b-form-feedback>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col class="p-a-0">
                                          <label>Recebedor</label>
                                          <multiselect v-model="form.recebedor"
                                          :options-limit="300"
                                          :limit="2"
                                          :limit-text="limitText"
                                          :options="optionsRecebedor"
                                          track-by="value"
                                          label="label"
                                          :hide-selected="true"
                                          placeholder="Recebedor ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"
                                          tag-placeholder="Selecionar"
                                          select-label="Selecionar"
                                          selected-label="Selecionado"
                                          deselect-label="Remover"
                                          :searchable="true"
                                          :loading="isLoadingRec"
                                          @search-change="listaClientesRecebedor"
                                          ></multiselect>
                                          <b-form-feedback class="text-danger" v-text="form.errors.get('recebedor.value')" v-if="form.errors.has('recebedor.value')"></b-form-feedback>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col class="p-a-0">
                                            <label>Tomador</label>
                                              <b-form-radio-group v-model="form.tomador" name="tomador">
                                                <b-form-radio value="0">Remetente</b-form-radio>
                                                <b-form-radio value="1">Expedidor</b-form-radio>
                                                <b-form-radio value="2">Recebedor</b-form-radio>
                                                <b-form-radio value="3">Destinatário</b-form-radio>
                                                <b-form-radio value="4">Outros</b-form-radio>
                                              </b-form-radio-group>
                                              <b-form-feedback class="text-danger" v-text="form.errors.get('tomador')" v-if="form.errors.has('tomador')"></b-form-feedback>
                                          </b-col>
                                          <b-col class="p-a-0">
                                              <label>Tipo da geração</label>
                                                <b-form-radio-group v-model="form.tipo_geracao" name="tipo_geracao">
                                                  <b-form-radio value="0">1 Por NF</b-form-radio>
                                                  <b-form-radio value="1">Agrupado</b-form-radio>
                                              </b-form-radio-group> <br/>
                                                <b-form-feedback class="text-danger" v-text="form.errors.get('tipo_geracao')" v-if="form.errors.has('tipo_geracao')"></b-form-feedback>

                                              <label>Total de documentos selecionados <br/><strong>{{ total_doc }} NFe's selecionadas </strong></label>
                                        </b-col>
                                    </b-row>
                                    <b-row v-if="form.tomador==4">
                                          <b-col class="p-a-0">
                                            <label>Tomador - Outros</label>
                                            <multiselect v-model="form.tomador_outros"
                                            :options-limit="300"
                                            :limit="2"
                                            :limit-text="limitText"
                                            :options="optionsTomador"
                                            track-by="value"
                                            label="label"
                                            :hide-selected="true"
                                            placeholder="Tomador ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"
                                            tag-placeholder="Selecionar"
                                            select-label="Selecionar"
                                            selected-label="Selecionado"
                                            deselect-label="Remover"
                                            :searchable="true"
                                            :loading="isLoadingTom"
                                            @search-change="listaClientesTomador"
                                            ></multiselect>
                                            <b-form-feedback class="text-danger" v-text="form.errors.get('tomador_outros.value')" v-if="form.errors.has('tomador_outros.value')"></b-form-feedback>
                                          </b-col>
                                    </b-row>
                                    <b-row>
                                      <b-col class="p-a-0">
                                        <label>Embarcação</label>
                                        <multiselect v-model="form.embarcacao"
                                        :options="optionsEmbarcacao"
                                        track-by="value"
                                        label="label"
                                        :hide-selected="true"
                                        placeholder="Selecione"
                                        tag-placeholder="Selecionar"
                                        select-label="Selecionar"
                                        selected-label="Selecionado"
                                        deselect-label="Remover"
                                        ></multiselect>
                                        <b-form-feedback class="text-danger" v-text="form.errors.get('embarcacao.value')" v-if="form.errors.has('embarcacao.value')"></b-form-feedback>
                                      </b-col>
                                        <b-col class="p-a-0">
                                            <label>Número da Viagem</label>
                                            <b-form-input type="text"
                                                          placeholder="Número da Viagem"
                                                          v-model="form.num_viagem"
                                                          name="num_viagem"
                                                          >
                                            </b-form-input>
                                            <b-form-feedback class="text-danger" v-text="form.errors.get('num_viagem')" v-if="form.errors.has('num_viagem')"></b-form-feedback>
                                      </b-col>
                                   </b-row>
                               </b-container>
                               <b-container fluid class="p-a-0">
                                    <label>Observação</label>

                                    <b-form-textarea id="textarea1"
                                                     name="obs"
                                                     v-model="form.obs"
                                                     placeholder="Observação"
                                                     :rows="6"
                                                     :max-rows="6">
                                    </b-form-textarea>
                                    <b-form-feedback class="text-danger" v-text="form.errors.get('obs')" v-if="form.errors.has('obs')"></b-form-feedback>
                                </b-container>
                            </b-tab>
                            <b-tab title="Documento Anterior">
                                <table class="table-striped">
                                    <thead>
                                        <tr>
                                            <th style="width: 5%">Tipo</th>
                                            <th style="width: 30%">Doc Anterior - Emitente</th>
                                            <th style="width: 15%">Chave</th>
                                            <th style="width: 10%">Nº Fiscal</th>
                                            <th style="width: 10%">Série</th>
                                            <th style="width: 15%">Data</th>
                                            <th style="width: 5%">Ação</th>
                                        </tr>
                                     </thead>
                                     <tbody>
                                        <tr class="bg-gray-light" style="display: table-row;" v-for="(row, index) in doctranspDig">
                                           <td>
                                                {{ row.tp_doc_descr }}
                                           </td>
                                           <td>
                                               {{ row.emi_nome }}
                                           </td>
                                           <td>
                                               <span v-if="row.tp_doc.valor==1">
                                                   <b-btn class="badge badge-warning" @click="showPopoverChaveCTe = !showPopoverChaveCTe" :id="'popoverButtonChaveCTe-sync'+row.chave" v-b-tooltip.hover.right="'Clique aqui para ver a chave completa ( Todas )'" variant="warning">{{ row.chave.substr(34,10) }}</b-btn>

                                                     <b-popover :show.sync="showPopoverChaveCTe" :target="'popoverButtonChaveCTe-sync'+row.chave" title="" data-html="true" placement="top">
                                                         {{ row.chave }}
                                                     </b-popover>
                                               </span>
                                           </td>
                                           <td>
                                               {{ row.num_fiscal }}
                                           </td>
                                           <td>
                                               {{ row.serie }}
                                           </td>
                                           <td>
                                               <span>{{ formatDate(row.dt_emissao, 'DD/MM/YYYY') }} </span>
                                           </td>
                                           <td>
                                               <i class="glyphicon glyphicon-remove" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Documento'" v-on:click="removeRowDocTranspDig(index);"></i>
                                           </td>
                                       </tr>
                                    </tbody>
                                </table>
                                <b-container fluid class="p-a-0">
                                    <b-row no-gutters>
                                        <label><strong>Emitente Documento</strong></label>
                                    </b-row>
                                    <b-row no-gutters>

                                        <b-col sm="3" md="3" class="m-t-5px p-a-0">
                                            <label>CNPJ</label>
                                            <b-form-input type="text"
                                                          placeholder="CNPJ"
                                                          v-model="form_doctransp.emi_cnpj_cpf_cuit"
                                                          >
                                            </b-form-input>
                                            <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('emi_cnpj_cpf_cuit')" v-if="form_doctransp.errors.has('emi_cnpj_cpf_cuit')"></b-form-feedback>
                                        </b-col>
                                        <b-col sm="9" md="9" class="m-t-5px p-a-0">
                                            <label>Nome</label>
                                            <b-form-input type="text"
                                                        placeholder="Nome"
                                                        v-model="form_doctransp.emi_nome"
                                                        >
                                            </b-form-input>
                                            <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('emi_nome')" v-if="form_doctransp.errors.has('emi_nome')"></b-form-feedback>
                                        </b-col>
                                    </b-row>
                                    <b-row no-gutters>
                                        <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                          <label>CEP *</label>
                                          <b-form-input type="text"
                                                        placeholder="CEP"
                                                        @change="getCep(3)"
                                                        v-model="form_doctransp.emi_cep"
                                                        >
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('emi_cep')" v-if="form_doctransp.errors.has('emi_cep')"></b-form-feedback>
                                        </b-col>

                                        <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                          <label>Municipio *</label>
                                          <multiselect v-model="form_doctransp.emi_municipio"
                                          :options="optionsMunicipios"
                                          track-by="value"
                                          label="label"
                                          :hide-selected="true"
                                          placeholder="Selecione"
                                          tag-placeholder="Selecionar"
                                          select-label="Selecionar"
                                          selected-label="Selecionado"
                                          deselect-label="Remover"
                                          ></multiselect>
                                          <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('emi_municipio.value')" v-if="form_doctransp.errors.has('emi_municipio.value')"></b-form-feedback>
                                        </b-col>


                                        <b-col sm="3" md="3" class="m-t-5px p-a-0">
                                          <label>Endereço *</label>
                                          <b-form-input type="text"
                                                        placeholder="Endereço"
                                                        v-model="form_doctransp.emi_endereco"
                                                        >
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('emi_endereco')" v-if="form_doctransp.errors.has('emi_endereco')"></b-form-feedback>
                                        </b-col>

                                        <b-col sm="1" md="1" class="m-t-5px p-a-0">
                                          <label>Número *</label>
                                          <b-form-input type="text"
                                                        placeholder="Número"
                                                        v-model="form_doctransp.emi_numero"
                                                        >
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('emi_numero')" v-if="form_doctransp.errors.has('emi_numero')"></b-form-feedback>
                                        </b-col>

                                        <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                          <label>Bairro *</label>
                                          <b-form-input type="text"
                                                        placeholder="Bairro"
                                                        v-model="form_doctransp.emi_bairro"
                                                        >
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('emi_bairro')" v-if="form_doctransp.errors.has('emi_bairro')"></b-form-feedback>
                                        </b-col>

                                        <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                          <label>Complemento</label>
                                          <b-form-input type="text"
                                                        placeholder="Complemento"
                                                        v-model="form_doctransp.emi_complemento"
                                                        >
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('emi_complemento')" v-if="form_doctransp.errors.has('emi_complemento')"></b-form-feedback>
                                        </b-col>
                                    </b-row>

                                    <b-row no-gutters>
                                        <label><strong>Destinatário Documento</strong></label>
                                    </b-row>
                                    <b-row no-gutters>
                                        <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                          <label>Tipo *</label>
                                          <multiselect v-model="form_doctransp.des_tp_pessoa"
                                          :options="optionsLivTpPessoa"
                                          track-by="value"
                                          label="label"
                                          :hide-selected="true"
                                          placeholder="Selecione"
                                          tag-placeholder="Selecionar"
                                          select-label="Selecionar"
                                          selected-label="Selecionado"
                                          deselect-label="Remover"
                                          ></multiselect>
                                          <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('des_tp_pessoa.value')" v-if="form_doctransp.errors.has('des_tp_pessoa.value')"></b-form-feedback>
                                        </b-col>

                                        <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                            <label>CNPJ/CPF/CUIT</label>
                                            <b-form-input type="text"
                                                          placeholder="CNPJ/CPF/CUIT"
                                                          v-model="form_doctransp.des_cnpj_cpf_cuit"
                                                          >
                                            </b-form-input>
                                            <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('des_cnpj_cpf_cuit')" v-if="form_doctransp.errors.has('des_cnpj_cpf_cuit')"></b-form-feedback>
                                        </b-col>
                                        <b-col sm="6" md="6" class="m-t-5px p-a-0">
                                            <label>Nome</label>
                                            <b-form-input type="text"
                                                        placeholder="Nome"
                                                        v-model="form_doctransp.des_nome"
                                                        >
                                            </b-form-input>
                                            <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('des_nome')" v-if="form_doctransp.errors.has('des_nome')"></b-form-feedback>
                                        </b-col>
                                        <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                          <label>PIN Suframa</label>
                                          <b-form-input type="text"
                                                        placeholder="PIN"
                                                        v-model="form_doctransp.des_pin"
                                                        >
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('des_pin')" v-if="form_doctransp.errors.has('des_pin')"></b-form-feedback>
                                        </b-col>
                                    </b-row>
                                    <b-row no-gutters>
                                        <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                          <label>CEP *</label>
                                          <b-form-input type="text"
                                                        placeholder="CEP"
                                                        @change="getCep(4)"
                                                        v-model="form_doctransp.des_cep"
                                                        >
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('des_cep')" v-if="form_doctransp.errors.has('des_cep')"></b-form-feedback>
                                        </b-col>

                                        <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                          <label>Municipio *</label>
                                          <multiselect v-model="form_doctransp.des_municipio"
                                          :options="optionsMunicipios"
                                          track-by="value"
                                          label="label"
                                          :hide-selected="true"
                                          placeholder="Selecione"
                                          tag-placeholder="Selecionar"
                                          select-label="Selecionar"
                                          selected-label="Selecionado"
                                          deselect-label="Remover"
                                          ></multiselect>
                                          <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('des_municipio.value')" v-if="form_doctransp.errors.has('des_municipio.value')"></b-form-feedback>
                                        </b-col>


                                        <b-col sm="3" md="3" class="m-t-5px p-a-0">
                                          <label>Endereço *</label>
                                          <b-form-input type="text"
                                                        placeholder="Endereço"
                                                        v-model="form_doctransp.des_endereco"
                                                        >
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('des_endereco')" v-if="form_doctransp.errors.has('des_endereco')"></b-form-feedback>
                                        </b-col>

                                        <b-col sm="1" md="1" class="m-t-5px p-a-0">
                                          <label>Número *</label>
                                          <b-form-input type="text"
                                                        placeholder="Número"
                                                        v-model="form_doctransp.des_numero"
                                                        >
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('des_numero')" v-if="form_doctransp.errors.has('des_numero')"></b-form-feedback>
                                        </b-col>

                                        <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                          <label>Bairro *</label>
                                          <b-form-input type="text"
                                                        placeholder="Bairro"
                                                        v-model="form_doctransp.des_bairro"
                                                        >
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('des_bairro')" v-if="form_doctransp.errors.has('des_bairro')"></b-form-feedback>
                                        </b-col>

                                        <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                          <label>Complemento</label>
                                          <b-form-input type="text"
                                                        placeholder="Complemento"
                                                        v-model="form_doctransp.des_complemento"
                                                        >
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('des_complemento')" v-if="form_doctransp.errors.has('des_complemento')"></b-form-feedback>
                                        </b-col>
                                    </b-row>

                                    <b-row no-gutters>
                                        <label><strong>Detalhes</strong></label>
                                    </b-row>
                                    <b-row no-gutters>
                                        <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                          <label>Tipo *</label>
                                          <multiselect v-model="form_doctransp.tp_doc"
                                          :options="optionsLivDocTranspTpDoc"
                                          track-by="value"
                                          label="label"
                                          :hide-selected="true"
                                          placeholder="Selecione"
                                          tag-placeholder="Selecionar"
                                          select-label="Selecionar"
                                          selected-label="Selecionado"
                                          deselect-label="Remover"
                                          ></multiselect>
                                          <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('tp_doc.value')" v-if="form_doctransp.errors.has('tp_doc.value')"></b-form-feedback>
                                        </b-col>

                                      <b-col sm="1" md="1" class="m-t-5px p-a-0">
                                          <label>Nº Fiscal *</label>
                                          <b-form-input type="text"
                                                        placeholder="Nº Fiscal"
                                                        v-model="form_doctransp.num_fiscal"
                                                        >
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('num_fiscal')" v-if="form_doctransp.errors.has('num_fiscal')"></b-form-feedback>
                                      </b-col>

                                      <b-col sm="1" md="1" class="m-t-5px p-a-0">
                                          <label>Série *</label>
                                          <b-form-input type="text"
                                                        placeholder="Série"
                                                        v-model="form_doctransp.serie"
                                                        >
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('serie')" v-if="form_doctransp.errors.has('serie')"></b-form-feedback>
                                      </b-col>

                                      <b-col sm="1" md="1" class="m-t-5px p-a-0">
                                          <label>Chave</label>
                                          <b-form-input type="text"
                                                        placeholder="Chave"
                                                        v-model="form_doctransp.chave"
                                                        >
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('chave')" v-if="form_doctransp.errors.has('chave')"></b-form-feedback>
                                      </b-col>

                                      <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                          <label>Data *</label>
                                          <v-date-picker v-model="form_doctransp.dt_emissao"
                                                         mode='single'
                                                         locale="pt-BR"
                                                         v-mask="'##/##/####'"
                                                         :popover='{visibility: "focus"}'
                                                         :attributes='date_attributes'
                                                         :input-props='{class: "form-control",placeholder: "dd/mm/yyyy"}'
                                                         @keyup.enter="doFilter">
                                          </v-date-picker>
                                          <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('dt_emissao')" v-if="form_doctransp.errors.has('dt_emissao')"></b-form-feedback>
                                      </b-col>

                                      <b-col sm="1" md="1" class="m-t-5px p-a-0">
                                          <label>Volume *</label>
                                          <b-form-input type="text"
                                                        placeholder="Volume"
                                                        v-model="form_doctransp.qtd_volume"
                                                        >
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('qtd_volume')" v-if="form_doctransp.errors.has('qtd_volume')"></b-form-feedback>
                                      </b-col>

                                      <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                          <label>Peso Bruto *</label>
                                          <b-form-input type="text"
                                                        v-money="qtd"
                                                        placeholder="Peso Bruto"
                                                        v-model="form_doctransp.peso_bruto"
                                                        >
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('peso_bruto')" v-if="form_doctransp.errors.has('peso_bruto')"></b-form-feedback>
                                      </b-col>

                                      <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                          <label>Valor Doc. *</label>
                                          <b-form-input type="text"
                                                        v-money="vlr"
                                                        placeholder="Valor Documento"
                                                        v-model="form_doctransp.vlr_total_cte"
                                                        >
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('vlr_total_cte')" v-if="form_doctransp.errors.has('vlr_total_cte')"></b-form-feedback>
                                      </b-col>
                                     </b-row>
                                     <b-row>
                                         <b-col sm="10" md="10">
                                         </b-col>
                                         <b-col sm="2" md="2" class="text-right">
                                             <b-btn variant="secondary" :disabled="isDisabled" v-on:click="addDocTranspDigitacao($event);" v-b-tooltip.hover.right="'Adicionar Documento'" style="cursor: pointer">
                                             Adicionar
                                             </b-btn>
                                         </b-col>
                                     </b-row>
                                 </b-container>
                             </b-tab>
                         </b-tabs>
                    </b-container>
                </form>

                <div slot="modal-footer" class="w-100">
                    <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                    <div class="float-right">
                        <div class="float-left" v-if="this.errors_array.length>0">
                            <b-btn class="badge badge-warning" @click="showPopover = !showPopover" id="popoverButton-sync" v-b-tooltip.hover.left="'Clique aqui para ver os erros encontrados'" variant="warning"><i class="fa fa-exclamation-triangle fa-2x"></i></b-btn>

                              <b-popover :show.sync="showPopover" target="popoverButton-sync" title="<strong>Erros Encontrados</strong>" data-html="true" placement="leftbottom">
                                <table class="table-striped" id="mais">
                                     <tbody>
                                         <tr class="bg-gray-light" style="display: table-row;" v-for="item in this.errors_array">
                                            <td>
                                              {{ item.erro }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                              </b-popover>
                          </div>
                        &nbsp;
                        <b-btn @click="showModal=false" variant="secondary">
                         Fechar
                        </b-btn>
                        <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                         Enviar
                        </b-btn>
                    </div>
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
import Vuetable from '../components/Vuetable'
import VuetablePagination from '../components/VuetablePagination'
import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
import CteVeiculoFilterBar from './CteVeiculoFilterBar'
import CteVeiculoDetalhes from './CteVeiculoDetalhes'
import {VMoney} from 'v-money'

import moment from 'moment'
Vue.component('cte-veiculo-detalhes', CteVeiculoDetalhes);

export default {
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        'vuetable-filterbar': CteVeiculoFilterBar,
        VMoney,
    },
    data () {
        return {
          date_attributes: [{key: 'today',highlight: true,dates: new Date()}],
          modal_titulo: '',
          modal_botao: '',
          modal_acao: '',
          loading: false,
          isDisabled: false,
          loadingData: true,
          showModal: false,
          isFullscreen: false,
          showPopover: false,
          optionsParamMotivo: [],
          optionsExpedidor: [],
          optionsRecebedor: [],
          optionsTomador: [],
          optionsLivCfop: [],
          isLoadingExp: false,
          isLoadingRec: false,
          isLoadingTom: false,
          helpForm: new Form({statusRecord: [], params: [], search:''}),
          vn_vlr_cte: 0,
          vn_aliquota: 0,
          total_doc: 0,
          errors_array: [],
          activateDesativate: [],
          optionsPortoOrigem: [],
          optionsPortoTransbordo: [],
          optionsPortoDestino: [],
          optionsEmbarcacao: [],
          optionsMunicipios: [],
          optionsLivTpPessoa: [],
          doctranspDig: [],
          optionsLivDocTranspTpDoc: [],
          vlr: {
              decimal: ',',
              thousands: '.',
              prefix: 'R$ ',
              precision: 2,
              masked: false /* doesn't work with directive */
          },
          aliquota: {
              decimal: ',',
              prefix: '% ',
              precision: 2,
              masked: false /* doesn't work with directive */
          },
          qtd: {
             decimal: ',',
             thousands: '.',
             precision: 3,
             masked: false /* doesn't work with directive */
          },
          help_form: new Form({
                    ocultarRecord: [],
          }),
          form: new Form({
                    cst: '',
                    vlr_cte: 0,
                    vlr_aliquota: 0,
                    vlr_imposto: 0,
                    vlr_total: 0,
                    percentual_reducao_bc: 0,
                    docfis_id: [],
                    porto_origem: [],
                    porto_transbordo: [],
                    porto_destino: [],
                    embarcacao: [],
                    num_viagem: '',
                    recebedor: [],
                    expedidor: [],
                    tomador: '',
                    tomador_outros: [],
                    cfop: [],
                    obs: '',
                    tipo_geracao: 0,
                    optionsMunicipios: [],
                    optionsLivTpPessoa: [],
                    optionsLivDocTranspTpDoc: [],
                    doctranspDig: [],
                    vlr_aliquota_afrmm: ''
                }),
        form_doctransp: new Form({ doctransp: []
                                  , tp_validacao: ''
                                  , chave: ''
                                  , emi_cnpj_cpf_cuit: ''
                                  , emi_ie: ''
                                  , emi_nome: ''
                                  , emi_cep: ''
                                  , emi_numero: ''
                                  , emi_bairro: ''
                                  , emi_endereco: ''
                                  , emi_municipio: []
                                  , emi_complemento: ''
                                  , des_tp_pessoa: []
                                  , des_cnpj_cpf_cuit: ''
                                  , des_ie: ''
                                  , des_nome: ''
                                  , des_cep: ''
                                  , des_numero: ''
                                  , des_bairro: ''
                                  , des_endereco: ''
                                  , des_municipio: []
                                  , des_complemento: ''
                                  , des_pin: ''
                                  , tp_doc: []
                                  , num_fiscal: ''
                                  , serie: ''
                                  , dt_emissao: ''
                                  , qtd_volume: ''
                                  , peso_bruto: 0
                                  , vlr_total_cte: 0
                                  , cep_busca: ''}),
          fields: [
            {
                name: '__checkbox',
                titleClass: 'center aligned',
                dataClass: 'center aligned'
            },
            {
              name: 'num_fiscal',
              title: 'Número Fiscal'
            },
            {
              name: 'serie',
              title: 'Serie'
            },
            {
              name: 'dt_emissao',
              title: 'Data Emissão',
              callback: 'formatDate|DD/MM/YYYY'
            },
            {
              name: 'doc_fiscal_partes_env.emi_cnpj',
              title: 'CNPJ'
            },
            {
              name: 'doc_fiscal_partes_env.emi_nome',
              title: 'Razão Social'
            },
            {
              name: '__slot:actions',
              title: 'Ações',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
            }
        ],
        css: {
            tableClass: 'table table-striped',
            loadingClass: 'loading',
            ascendingIcon: 'glyphicon glyphicon-chevron-up',
            descendingIcon: 'glyphicon glyphicon-chevron-down',
            handleIcon: 'glyphicon glyphicon-menu-hamburger',
            detailRowClass: 'vuetable-detail-row',
        },
        moreParams: {}
       }
    },
    directives: {
        money: VMoney,
        aliquota: VMoney
    },
    mounted() {
        this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
        this.$events.$on('filter-reset', e => this.onFilterReset());
        this.getLivGeral();
      },
    methods: {
        onPaginationData (paginationData) {
          this.$refs.pagination.setPaginationData(paginationData)
          this.$refs.paginationInfo.setPaginationData(paginationData)
        },
        onChangePage (page) {
          this.$refs.vuetable.changePage(page)
        },
        onFilterSet (data_filter) {
            this.moreParams = {
                'num_fiscal':  data_filter.num_fiscal,
                'emi_cnpj':  data_filter.emi_cnpj,
                'ocultar':  data_filter.ocultar,
                'chave':  data_filter.chave,
                'dt_inicio': data_filter.dt_inicio,
                'dt_fim': data_filter.dt_fim
            }
            Vue.nextTick( () => this.$refs.vuetable.reload())
        },
        onFilterReset () {
            this.loadingData = true;
            this.moreParams = {}
            Vue.nextTick( () => this.$refs.vuetable.refresh())
        },
        onFilterShowHide() {
            if(this.vuetableFilterRow)
            {
                this.$store.commit('setVuetableFilterRow', false);
            }
            else
            {
                this.$store.commit('setVuetableFilterRow', true);
            }
        },
        onLoaded: function () {
            this.dataExport = this.$refs.vuetable.tableData;
            this.loadingData = false;
            this.$store.commit('setVuetableFilterButton', false);
        },
        onDetail (data, field, event) {
            this.$refs.vuetable.toggleDetailRow(data.docfis_id);
        },
        formatDate (value, fmt = 'D MMM YYYY') {
          return (value == null)
            ? ''
            : moment(value, 'YYYY-MM-DD').format(fmt)
        },
        handleOk(e)
        {
            e.preventDefault();
            if(this.modal_acao=="i")
            {
               this.onStore();
            }
        },
        onCreate (data) {
            this.modal_titulo = "Gerar CTE";
            this.modal_botao = "Gerar CTE";
            this.modal_acao = "i";
            this.loading = false;
            this.isDisabled = false;
            this.total_doc = 0;
            this.form.reset();
            this.form.docfis_id = '';
            this.form.docfis_id = [];
            this.form.tipo_geracao = 0;
            this.$refs.vuetable.selectedTo.forEach((obj)=>{
                this.form.docfis_id.push({ id: obj })
                this.total_doc = this.total_doc+1;
            });

            this.$refs.modal_form.show();
        },
        addDocTranspDigitacao() {
            this.loadingAddDoc = true;
            this.isDisabledAddDoc = true;
            this.form_doctransp.tp_validacao = 2;
            this.form_doctransp.doctransp = this.doctranspDig;
            // Chamada backend para validar
            this.form_doctransp.dt_emissao = this.formatDateSubmit(this.form_doctransp.dt_emissao);
            this.form_doctransp.post('/api/associar/adddoctranspdigitacao').then(response =>
            {
                this.doctranspDig.push({
                    emi_cnpj_cpf_cuit: this.form_doctransp.emi_cnpj_cpf_cuit,
                    emi_ie: this.form_doctransp.emi_ie,
                    emi_nome: this.form_doctransp.emi_nome,
                    emi_cep: this.form_doctransp.emi_cep,
                    emi_numero: this.form_doctransp.emi_numero,
                    emi_bairro: this.form_doctransp.emi_bairro,
                    emi_endereco: this.form_doctransp.emi_endereco,
                    emi_municipio: this.form_doctransp.emi_municipio,
                    emi_complemento: this.form_doctransp.emi_complemento,
                    des_tp_pessoa: this.form_doctransp.des_tp_pessoa,
                    des_cnpj_cpf_cuit: this.form_doctransp.des_cnpj_cpf_cuit,
                    des_ie: this.form_doctransp.des_ie,
                    des_nome: this.form_doctransp.des_nome,
                    des_cep: this.form_doctransp.des_cep,
                    des_numero: this.form_doctransp.des_numero,
                    des_bairro: this.form_doctransp.des_bairro,
                    des_endereco: this.form_doctransp.des_endereco,
                    des_municipio: this.form_doctransp.des_municipio,
                    des_complemento: this.form_doctransp.des_complemento,
                    des_pin: this.form_doctransp.des_pin,
                    tp_doc: this.form_doctransp.tp_doc,
                    tp_doc_descr: this.form_doctransp.tp_doc.label,
                    chave: this.form_doctransp.chave,
                    num_fiscal: this.form_doctransp.num_fiscal,
                    serie: this.form_doctransp.serie,
                    dt_emissao: this.form_doctransp.dt_emissao,
                    qtd_volume: this.form_doctransp.qtd_volume,
                    peso_bruto: this.form_doctransp.peso_bruto,
                    vlr_total_cte: this.form_doctransp.vlr_total_cte
                });

                this.loadingAddDoc = false;

                this.form_doctransp.chave = "";
                this.form_doctransp.reset();
                this.isDisabledAddDoc = false;
                vm.$snotify.success(response.message, response.title);
                new ReturnApi(response, this);
            })
            .catch(errors =>
            {
                this.loadingAddDoc = false;
                this.isDisabledAddDoc = false;
                this.errors_array = '';
                this.errors_array = [];
                for(var property in errors)
                {
                  if(errors.hasOwnProperty(property))
                  {
                     if(typeof(errors[property]) === 'object')
                     {
                     errors[property].forEach((obj)=>{
                        this.errors_array.push({erro: obj});
                     });
                     }
                  }
                }
                new ReturnApi(errors, this)
            });
        },
        formatDateSubmit (value, fmt = 'DD/MM/YYYY') {
            return (value == null || value == "")
              ? ''
              : moment(value, 'YYYY/MM/DD HH:mm').format(fmt)
        },
        getCep(en_tipo)
        {
            if(en_tipo==1)
            {
                this.helpForm.cep_busca = this.helpForm.emi_cep;
            }
            else if(en_tipo==2)
            {
                this.helpForm.cep_busca = this.helpForm.des_cep;
            }
            else if(en_tipo==3)
            {
                this.helpForm.cep_busca = this.form_doctransp.emi_cep;
            }
            else if(en_tipo==4)
            {
                this.helpForm.cep_busca = this.form_doctransp.des_cep;
            }

            //Nova variável "cep" somente com dígitos.
            var cep = this.helpForm.cep_busca.replace(/\D/g, '');

            //Verifica se campo cep possui valor informado.
            if (cep != "")
            {

                //Expressão regular para validar o CEP.
                var validacep = /^[0-9]{8}$/;

                //Valida o formato do CEP.
                if(validacep.test(cep))
                {
                    this.loadingCep = true;
                    this.helpForm.post('/api/cep/pesquisar').then(response =>
                    {
                        new ReturnApi(response, this, true, false, false);

                        if(en_tipo==1)
                        {
                            this.helpForm.errors.clear();
                            response.forEach((obj)=>{
                                this.helpForm.emi_endereco = obj.logradouro;
                                this.helpForm.emi_bairro = obj.bairro;
                                this.helpForm.emi_complemento = obj.complemento;
                                this.optionsMunicipios.forEach((obj2)=>{
                                    if(obj2.ibge==obj.ibge)
                                    {
                                        this.helpForm.emi_municipio = { label: obj2.label, value: obj2.value };
                                    }
                                });
                            });
                        }
                        else if(en_tipo==2)
                        {
                            this.helpForm.errors.clear();
                            response.forEach((obj)=>{
                                this.helpForm.des_endereco = obj.logradouro;
                                this.helpForm.des_bairro = obj.bairro;
                                this.helpForm.des_complemento = obj.complemento;
                                this.optionsMunicipios.forEach((obj2)=>{
                                    if(obj2.ibge==obj.ibge)
                                    {
                                        this.helpForm.des_municipio = { label: obj2.label, value: obj2.value };
                                    }
                                });
                            });
                        }
                        else if(en_tipo==3)
                        {
                            this.form_doctransp.errors.clear();
                            response.forEach((obj)=>{
                                this.form_doctransp.emi_endereco = obj.logradouro;
                                this.form_doctransp.emi_bairro = obj.bairro;
                                this.form_doctransp.emi_complemento = obj.complemento;
                                this.optionsMunicipios.forEach((obj2)=>{
                                    if(obj2.ibge==obj.ibge)
                                    {
                                        this.form_doctransp.emi_municipio = { label: obj2.label, value: obj2.value };
                                    }
                                });
                            });
                        }
                        else if(en_tipo==4)
                        {
                            this.form_doctransp.errors.clear();
                            response.forEach((obj)=>{
                                this.form_doctransp.des_endereco = obj.logradouro;
                                this.form_doctransp.des_bairro = obj.bairro;
                                this.form_doctransp.des_complemento = obj.complemento;
                                this.optionsMunicipios.forEach((obj2)=>{
                                    if(obj2.ibge==obj.ibge)
                                    {
                                        this.form_doctransp.des_municipio = { label: obj2.label, value: obj2.value };
                                    }
                                });
                            });
                        }
                        this.loadingCep = false;

                    })
                    .catch(errors =>
                    {
                        this.loadingCep = false;
                        new ReturnApi(errors, this)
                    });
                }
                else
                {
                    if(en_tipo==1)
                    {
                        var errors = { "errors": { "emi_cep": [ "Cep inválido"] }};
                        this.helpForm.errors.record(errors.errors);
                    }
                    else if(en_tipo==2)
                    {
                        var errors = { "errors": { "des_cep": [ "Cep inválido"] }};
                        this.helpForm.errors.record(errors.errors);
                    }
                    else if(en_tipo==3)
                    {
                        var errors = { "errors": { "emi_cep": [ "Cep inválido"] }};
                        this.form_doctransp.errors.record(errors.errors);
                    }
                    else if(en_tipo==4)
                    {
                        var errors = { "errors": { "des_cep": [ "Cep inválido"] }};
                        this.form_doctransp.errors.record(errors.errors);
                    }
                }
            }
        },
        onStore() {
            this.loading = true;
            this.isDisabled = true;
            this.$refs.vuetable.selectedTo = [];
            this.form.doctranspDig = this.doctranspDig;
            this.form.post('/api/cteveiculo/store').then(response =>
            {
                new ReturnApi(response, this);
                Vue.nextTick( () => this.$refs.vuetable.reload());
            })
            .catch(errors =>
            {
                this.loadingAddDoc = false;
                this.isDisabledAddDoc = false;
                this.errors_array = '';
                this.errors_array = [];
                for(var property in errors)
                {
                  if(errors.hasOwnProperty(property))
                  {
                     if(typeof(errors[property]) === 'object')
                     {
                     errors[property].forEach((obj)=>{
                        this.errors_array.push({erro: obj});
                     });
                     }
                  }
                }
                new ReturnApi(errors, this)
            });
        },
        calcCte() {
            this.vn_vlr_cte = this.form.vlr_cte.replace( ".", "" );
            this.vn_vlr_cte = this.vn_vlr_cte.replace( ",", "." );
            this.vn_vlr_cte = parseFloat( this.vn_vlr_cte.replace(/[^0-9.]/g, "") );

            this.vn_aliquota = this.form.vlr_aliquota.replace( ".", "" );
            this.vn_aliquota = this.vn_aliquota.replace( ",", "." );
            this.vn_aliquota = parseFloat( this.vn_aliquota.replace( /[^0-9.]/g, "") );

            this.form.vlr_imposto = Number((this.vn_vlr_cte/((100-this.vn_aliquota)/100))-this.vn_vlr_cte).toFixed(2);

            this.vn_vlr_total = parseFloat(this.vn_vlr_cte)+parseFloat(this.form.vlr_imposto);
            this.form.vlr_total = Number(this.vn_vlr_total).toFixed(2);
            // this.form.vlr_imposto = this.vn_vlr_cte*(this.vn_aliquota).toFixed(2);
        },
        /*calcCte() {
            this.vn_vlr_cte = this.form.vlr_cte.replace( ".", "" );
            this.vn_vlr_cte = this.vn_vlr_cte.replace( ",", "." );
            this.vn_vlr_cte = parseFloat( this.vn_vlr_cte.replace(/[^0-9.]/g, "") );

            this.vn_aliquota = this.form.vlr_aliquota.replace( ".", "" );
            this.vn_aliquota = this.vn_aliquota.replace( ",", "." );
            this.vn_aliquota = parseFloat( this.vn_aliquota.replace( /[^0-9.]/g, "") );

            this.form.vlr_imposto = Number(this.vn_vlr_cte-(this.vn_vlr_cte*((100-this.vn_aliquota)/100))).toFixed(2);
            //this.form.vlr_imposto = (this.vn_vlr_cte*(this.vn_aliquota.toFixed(2))).toFixed(2);
        },*/
        getLivGeral() {
            this.helpForm.get('/api/cteveiculo/jsonlistGeral').then(response =>
            {
                new ReturnApi(response, this, true, false, false);
                response.porto.forEach((obj)=>{
                    this.optionsPortoOrigem.push({ label: obj.cd, value: obj.porto_id })
                })
                response.porto.forEach((obj)=>{
                    this.optionsPortoDestino.push({ label: obj.cd, value: obj.porto_id })
                })
                response.porto.forEach((obj)=>{
                    this.optionsPortoTransbordo.push({ label: obj.cd, value: obj.porto_id })
                })
                response.embarcacao.forEach((obj)=>{
                    this.optionsEmbarcacao.push({ label: obj.cd, value: obj.embarcacao_id })
                })
                response.cfop.forEach((obj)=>
                {
                    this.optionsLivCfop.push({ label: obj.valor+" - "+obj.descr, value: obj.valor })
                })
                response.municipios.forEach((obj)=>
                {
                    this.optionsMunicipios.push({ label: obj.nome, ibge: obj.cd_ibge, value: obj.municipio_id })
                })
                response.doc_transp_tp_doc.forEach((obj)=>
                {
                    this.optionsLivDocTranspTpDoc.push({ label: obj.descr, value: obj.valor })
                })

                response.tp_pessoa.forEach((obj)=>
                {
                    this.optionsLivTpPessoa.push({ label: obj.descr, value: obj.valor })
                })
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        listaClientesExpedidor(search) {
            if(search.length>=3)
            {
                this.isLoadingExp = true;
                this.helpForm.search = search;
                this.helpForm.post('/api/pessoa/jsonlist').then(response =>
                {
                    this.optionsExpedidor = [];
                    new ReturnApi(response, this, true, false, false);

                    response.items.forEach((obj)=>
                    {
                        this.optionsExpedidor.push({ label: obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                    });
                    response.itemsE.forEach((obj)=>
                    {
                        this.optionsExpedidor.push({ label: obj.pessoa.cd+" - "+obj.nome+" - "+obj.cuit, value: obj.pessoa_id })
                    });
                    this.isLoadingExp = false;
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, this)
                });
            }
        },
        listaClientesRecebedor(search) {
            if(search.length>=3)
            {
                this.isLoadingRec = true;
                this.helpForm.search = search;
                this.helpForm.post('/api/pessoa/jsonlist').then(response =>
                {
                    this.optionsRecebedor = [];
                    new ReturnApi(response, this, true, false, false);

                    response.items.forEach((obj)=>
                    {
                        this.optionsRecebedor.push({ label: obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                    });
                    response.itemsE.forEach((obj)=>
                    {
                        this.optionsRecebedor.push({ label: obj.pessoa.cd+" - "+obj.nome+" - "+obj.cuit, value: obj.pessoa_id })
                    });
                    this.isLoadingRec = false;
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, this)
                });
            }
        },
        listaClientesTomador(search) {
            if(search.length>=3)
            {
                this.helpForm.search = search;
                this.helpForm.post('/api/pessoa/jsonlist').then(response =>
                {
                    this.optionsTomador = [];
                    new ReturnApi(response, this, true, false, false);
                    this.isLoadingTom = true;
                    response.items.forEach((obj)=>
                    {
                        this.optionsTomador.push({ label: obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                    });
                    response.itemsE.forEach((obj)=>
                    {
                        this.optionsTomador.push({ label: obj.pessoa.cd+" - "+obj.nome+" - "+obj.cuit, value: obj.pessoa_id })
                    });
                    this.isLoadingTom = false;
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, this)
                });
            }
        },
        expandFullscreen() {
            this.isFullscreen = !this.isFullscreen;
        },
        limitText (count) {
          return ' e ${count} outros clientes'
        },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito)
        {
            var cnpj_formatado
            var pad = "00000000"
            var cnpj_base = pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
            var pad = "0000"
            var cnpj_filial = pad.substring(0, pad.length - cnpj_filial.toString().length) + cnpj_filial;
            var pad = "00"
            var cnpj_digito = pad.substring(0, pad.length - cnpj_digito.toString().length) + cnpj_digito;

            return cnpj_base+""+cnpj_filial+""+cnpj_digito;
        },
        formatTypedDate: function (dateString)
        {
           let result = dateString.split('/')
           return result[2] + '-' + result[1] + '-' + result[0] + 'T00:00:00-03:00'
        },
        removeRowDocTranspDig: function(index) {
            this.doctranspDig.splice(index, 1);
        },
        onOcultar(action, data, tipo)
        {
            // Tipo = true = Checkbox
            if(tipo)
            {
                this.help_form.ocultarRecord = [];
                this.help_form.ocultarRecord.push({ id: data.docfis_id, status: action });
            }
            else
            {
                this.help_form.ocultarRecord = [];
                this.$refs.vuetable.selectedTo.forEach((obj)=>{
                    this.help_form.ocultarRecord.push({ id: obj, status: action })
                });
            }

            this.loading = true;
            this.isDisabled = true;
            this.help_form.post('/api/gerarcte/ocultar').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
    },
    computed: {
        vuetableFilterRow: {
            get () {
                return this.$store.getters.vuetable.filterRow;
            },
        },
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            }
        }
    }
}
</script>
